import { ISmartStorageProviderV2, StorageProvider } from '../support/StorageProvider.ts';

export class LocalStorageLastCodeVerifierProvider {
    static inject = () => [StorageProvider];
    constructor(storageV2: StorageProvider){
        this.code_verifier = storageV2.getStringProvider('PKCE.code_verifier', { userNeutral: true, storageType: 'localStorage' } );
    }

    store = ({ code_verifier }: { code_verifier: string }) => {
        this.code_verifier.set(code_verifier);
    };

    getLastVerifier = (): { code_verifier?: string } => {
        const code_verifier = this.code_verifier.get();
        return { code_verifier };
    };

    private code_verifier: ISmartStorageProviderV2<string>;
}
